import { render, staticRenderFns } from "./InternationalShipments.vue?vue&type=template&id=0b775013&scoped=true&"
import script from "./InternationalShipments.vue?vue&type=script&lang=js&"
export * from "./InternationalShipments.vue?vue&type=script&lang=js&"
import style0 from "./InternationalShipments.vue?vue&type=style&index=0&id=0b775013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b775013",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAlert,VBtn,VSnackbar})
